module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Folder-check-d0a1ec30a404d7bb2c7553f9ad4247d8.svg";